/**
 * Formattazione di importi e scadenze del piano rate.
 *
 * Gli stessi numeri compaiono nella card del TD, nel footer del viaggiatore, nella modale
 * di pagamento e nella proposta condivisa: se ognuno li formatta a modo suo il cliente
 * vede "€1.200,00" in un punto e "€1200" due centimetri piu' sotto.
 */

/**
 * Importo in euro. La valuta e' EUR ovunque nel piano rate (payment_plans.currency).
 *
 * `showSymbol: false` per i punti dove la valuta e' gia' detta da un'icona accanto:
 * il simbolo ripetuto due volte si legge come un errore.
 */
export const formatPlanAmount = (
    value: number | null | undefined,
    { showSymbol = true }: { showSymbol?: boolean } = {},
): string => {
    if (value == null) return '—';
    const amount = value.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return showSymbol ? `€${amount}` : amount;
};

/** Scadenza estesa: "12 settembre 2026". Per le date ISO YYYY-MM-DD delle rate. */
export const formatPlanDate = (iso: string | null | undefined, locale = 'it-IT'): string => {
    if (!iso) return '—';
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return '—';
    return date.toLocaleDateString(locale, { day: 'numeric', month: 'long', year: 'numeric' });
};

/** Scadenza compatta: "12 set". Per il riepilogo accanto al prezzo, dove lo spazio e' poco. */
export const formatPlanDateShort = (iso: string | null | undefined, locale = 'it-IT'): string => {
    if (!iso) return '—';
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return '—';
    return date.toLocaleDateString(locale, { day: 'numeric', month: 'short' });
};
